/* eslint-disable react/jsx-key */
import React, { FC, useState } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import PauseImg from '~/assets/images/pause.webp';
import PausePreviewImg from '~/assets/images/pause_preview.png';
import Button from '~/components/atoms/buttons/Button';
import Image from '~/components/atoms/Image';
import Loader from '~/components/atoms/Loader';
import Benefits from '~/components/molecules/Benefits';
import projectConfig from '~/projects/config';
import analytics from '~/services/analytics';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  onSubmit: () => Promise<void>;
  onRefuse: () => void;
};

const UnpauseModal: FC<Props> = ({ onSubmit, onRefuse }) => {
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation('modal');

  const handleSubmit = async (): Promise<void> => {
    try {
      setIsLoading(true);
      analytics.trackEvent('holiday pause - need to unpause click');

      await onSubmit();
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      {isLoading ? (
        <Loader isLoading={isLoading} />
      ) : (
        <>
          <div className={styles.image}>
            <Image src={PauseImg} preview={PausePreviewImg} />
          </div>

          <Typography
            variant={Typographies.TITLE_LARGE}
            component="div"
            className={styles.title}
          >
            {t('unpause_sub.title', 'Your plan is paused')}
          </Typography>

          <Typography
            variant={Typographies.BODY_LARGE}
            component="div"
            className={styles.text}
          >
            {t('unpause_sub.text_v1', {
              project: projectConfig.getProjectName(),
              defaultValue: 'Unpause to full access to {{project}} features',
            })}
          </Typography>

          <div className={styles.benefits}>
            <Benefits />
          </div>

          <div className={styles.buttons_container}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              className={styles.submit_button}
            >
              {t('general:unpause_plan', 'Unpause Plan')}
            </Button>

            <Button variant="text" color="primary" onClick={onRefuse}>
              {t('general:dismiss', 'Dismiss')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default UnpauseModal;
